import React from 'react';
import './styles.css';
import { getStore, usePlayerStore } from '../../../../stores/StoreContext';
import FocusHoverControls from './Focus';
import OverviewHoverControls from './Overview';
/**
 * Renders the video controls bar.
 *
 * The controls bar is a container for several controls, including a timeline,
 * play/pause button, timer, annotation options, and annotation labels.
 *
 * @returns {React.ReactElement} The controls bar.
 */
const HoverControls = () => {
  const AppStore = getStore('appStore');
  const overlay = usePlayerStore((state) => state.overlay);

  return (
    <>
      {!overlay && (
        <>
          {AppStore.viewMode !== 'overview' && <FocusHoverControls />}
          {AppStore.viewMode === 'overview' && <OverviewHoverControls />}
        </>
      )}
    </>
  );
};

export default HoverControls;
